import { atom } from "recoil"

export const matchingOtherProfileRequestIdState = atom({
  key: "atoms/matching/matchingOtherProfileRequestIdState",
  default: 0,
})
